function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.02 1.5a.5.5 0 01.492.41l.008.09v1.44h2.25a.5.5 0 01.35.143l.062.074L16.786 6 19.21 6a.5.5 0 01.497.446l.002.084-.254 4.167 2.736.803a.5.5 0 01.35.58l-.025.082-3.437 8.809c.137.097.265.129.44.129.3 0 .458-.092.763-.443l.11-.13c.552-.665.916-.927 1.628-.927a.5.5 0 110 1c-.294 0-.45.09-.751.439l-.11.13c-.554.667-.921.931-1.64.931-.66 0-1.025-.224-1.516-.783l-.129-.15c-.38-.454-.537-.567-.864-.567-.295 0-.452.091-.758.443l-.108.127c-.556.668-.92.93-1.634.93-.659 0-1.02-.224-1.509-.783l-.125-.147c-.381-.457-.538-.57-.866-.57-.295 0-.452.091-.758.443l-.108.127c-.556.668-.92.93-1.634.93-.658 0-1.022-.224-1.512-.783l-.125-.146c-.384-.458-.54-.571-.863-.571-.29 0-.444.09-.746.439l-.11.13c-.554.667-.92.931-1.634.931-.659 0-1.02-.224-1.509-.783l-.125-.147c-.381-.457-.538-.57-.866-.57a.5.5 0 010-1c.659 0 1.02.223 1.509.783l.125.147c.381.457.538.57.866.57a.68.68 0 00.455-.143l-3.44-8.795a.5.5 0 01.244-.63l.08-.032 2.727-.8-.245-4.17a.5.5 0 01.415-.523L4.84 6l2.423-.001 1.604-2.342a.5.5 0 01.316-.207l.097-.01h2.24V2a.5.5 0 01.5-.5zm.508 8.208l8.858 2.598-3.069 7.859c-.396-.4-.742-.565-1.307-.565-.659 0-1.02.223-1.509.783l-.233.274c-.306.352-.463.443-.758.443s-.452-.091-.758-.443l-.233-.274c-.347-.396-.629-.624-.998-.723l.007-9.952zm-1-.003l-.008 9.95c-.38.096-.666.324-1.019.728l-.233.274c-.306.352-.463.443-.758.443-.296 0-.455-.093-.762-.444l-.237-.277c-.447-.51-.787-.74-1.344-.774l-.115-.005-.065-.01c-.334-.034-.67.074-1.014.31l-.148.109-.111.09-3.05-7.794 8.865-2.6zm2.978-5.265l1.068 1.559h-7.1L9.544 4.44h4.963zm3.964 5.968L18.678 7H5.37l.201 3.411 6.308-1.85.151-.021.14.02 6.3 1.848z"
  }));
};
const SvgCruisesBrand = styled(BaseComponent).withConfig({
  displayName: "CruisesBrand__SvgCruisesBrand",
  componentId: "sc-1izgv4t-0"
})(["outline:none;"]);
SvgCruisesBrand.isIcon = true;
export default SvgCruisesBrand;